import axios from 'axios';
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/lanes`;

export const createLaneEvent = async (driveId, laneId, eventData) => {
  await new Promise((resolve) => setTimeout(resolve, 500));
  const newEvent = {
    id: Date.now(), // Simple ID generation
    ...eventData,
    sector: eventData.sectorId || laneId,
    sectorLabel: eventData.sectorId || laneId,
  };
  return {
    data: newEvent,
    status: 'success',
  };
};

export const updateLaneEvent = async (driveId, laneId, eventId, eventData) => {
  await new Promise((resolve) => setTimeout(resolve, 500));
  return {
    data: {
      id: eventId,
      ...eventData,
      sector: eventData.sector || eventData.sectorId || laneId,
      sectorLabel: eventData.sectorLabel || eventData.sectorId || laneId,
    },
    status: 'success',
  };
};

export const deleteLaneEvent = async (driveId, laneId, eventId) => {
  await new Promise((resolve) => setTimeout(resolve, 300));
  return {
    data: laneId,
    status: 'success',
  };
};

export const getTimelineData = async (driveId) => {
  await new Promise((resolve) => setTimeout(resolve, 300));
  return {
    data: {
      duration: 120,
      sectors: ['L1', 'L3', 'AUX'],
    },
    status: 'success',
  };
};

// Submit lane data (create)
export const submitLaneData = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/submit`, data);
  return response;
};

// Get lanes for a drive (with GPS coordinates)
export const getLanesForDrive = async (driveId) => {
  const response = await axios.get(`${API_BASE_URL}/${driveId}`);
  return response;
};

// Get lane GPS data from backend
export const getLaneGpsData = async (driveId) => {
  const response = await axios.get(`${API_BASE_URL}/${driveId}/gps`);
  return response;
};

// Update lane data (modify existing record)
export const updateLaneData = async (data) => {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const success = Math.random() > 0.2;
  if (success) {
    return {
      status: 'success',
      message: 'Data updated successfully',
      data,
    };
  } else {
    throw new Error('Update failed');
  }
};
